import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-custom-button',
  templateUrl: './custom-button.component.html',
  styleUrls: ['./custom-button.component.scss']
})
export class CustomButtonComponent implements OnInit {

  @Input() btnClass: string = '';
  @Input() btnTitle: string = '';

  @Output() onButtonClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }
  onClick() {
    this.onButtonClick.emit();
  }
}
